import React from 'react'
import { Button } from 'antd'
import { Card, CardBody, CardHeader } from '../../components/other/card/card'
import ReusableTable from '../../components/other/ReuseableTable'
import { columns } from './tableColumns'

function ReportRequestsTable ({
  reportRequests,
  isLoadingRequests,
  pagination,
  handleTableChange,
  refetch
}) {
  return (
    <Card className='mt-4'>
      <CardHeader>
        <div className='d-flex justify-content-between align-items-center'>
          <span>Report Requests</span>
          <Button onClick={refetch} loading={isLoadingRequests}>
            Refresh
          </Button>
        </div>
      </CardHeader>
      <CardBody>
        <ReusableTable
          columns={columns}
          data={reportRequests?.results}
          rowKey='id'
          loading={isLoadingRequests}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: reportRequests?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </CardBody>
    </Card>
  )
}

export default ReportRequestsTable
